import axios from 'axios';
import { Component } from "react";
import { baseUrl, config } from './index.js';

export default class DocumentService extends Component {
  static createDocument = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/create_document?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAllDocuments = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_all_documents?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      config.data = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static updateStatus = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/approve_document?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.params = '';
      config.data = data;
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };

  static getAllDocumentByCountry = async (data) => {
    try {
      const config = {
        url: `${baseUrl}/wp/v2/document_cat_stats?lang=${localStorage.getItem('localLang')}`,
        method: 'get',
        params: data,
      };
      const response = await axios(config);
      return response.data || [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };
}
